import * as actionTypes from "../actions";

import moment from "../../moment/moment";
import { getRoundTime } from "../../helpers";
import * as uiConsts from '../../constants/ui';
import { NOTIFICATION_CENTER_TAB_KEYS } from "@/features/notification-center/constants/constants";

const initialState = {
    selectedDay: moment().startOf('day'),
    // selectedDay: moment().startOf('day').toISOString(),
    stubSelectedDay: moment().startOf('day'),

    timeline : {
        startTime: moment().startOf('day').add(9, 'hour'),
        endTime: moment().startOf('day').add(24, 'hour')
    },

    selectedTime: getRoundTime(moment().seconds(0), uiConsts.TIME_SLICE).format(uiConsts.TIME_FORMAT),
    syncedTime: true,

    memoViewVisible: false,

    reservationModalVisible: false,
    calendarModalVisible: false,
    searchReservationModalVisible: false,
    customerModalVisible: false,
    customerFileModalVisible: false,
    customerProfileModalVisible: false,
    customerDuplicatesModalVisible: false,
    tableModalVisible: false,
    tableLinkModalVisible: false,
    tableLinkViewModalVisible: false,
    zoneModalVisible: false,
    artefactModalVisible: false,
    baresthoFeedbackModalVisible: false,

    tableExplorerModalVisible: false,
    tableExplorerDate: null,

    tableSelectionModalVisible: false,
    tableSummaryVisible: false,

    notificationTabVisible: false,
    notificationCenterActiveTab : NOTIFICATION_CENTER_TAB_KEYS.RESERVATIONS,
    activeReservation: 0,
};

const uiReducer = (state = initialState, action) => {
    switch (action.type) {
        case actionTypes.OPEN_RESERVATION_MODAL:
            return {
                ...state,
                reservationModalVisible: true
            };
        case actionTypes.CLOSE_RESERVATION_MODAL:
            return {
                ...state,
                reservationModalVisible: false
            };
        case actionTypes.OPEN_TABLE_EXPLORER_MODAL:
            return {
                ...state,
                tableExplorerModalVisible: true,
                tableExplorerDate: action.date
            };
        case actionTypes.CLOSE_TABLE_EXPLORER_MODAL:
            return {
                ...state,
                tableExplorerModalVisible: false
            };
        case actionTypes.OPEN_TABLE_SELECTION_MODAL:
            return {
                ...state,
                tableSelectionModalVisible: true,
            };
        case actionTypes.CLOSE_TABLE_SELECTION_MODAL:
            return {
                ...state,
                tableSelectionModalVisible: false,
            };
        case actionTypes.OPEN_TABLE_MODAL:
            return {
                ...state,
                tableModalVisible: true
            };
        case actionTypes.CLOSE_TABLE_MODAL:
            return {
                ...state,
                tableModalVisible: false
            };
        case actionTypes.OPEN_TABLELINK_MODAL:
            return {
                ...state,
                tableLinkModalVisible: true
            };
        case actionTypes.CLOSE_TABLELINK_MODAL:
            return {
                ...state,
                tableLinkModalVisible: false
            };
        case actionTypes.OPEN_TABLELINK_VIEW_MODAL:
            return {
                ...state,
                tableLinkViewModalVisible: true
            };
        case actionTypes.CLOSE_TABLELINK_VIEW_MODAL:
            return {
                ...state,
                tableLinkViewModalVisible: false
            };
        case actionTypes.OPEN_ZONE_MODAL:
            return {
                ...state,
                zoneModalVisible: true
            };
        case actionTypes.CLOSE_ZONE_MODAL:
            return {
                ...state,
                zoneModalVisible: false
            };
        case actionTypes.OPEN_CUSTOMER_MODAL:
            return {
                ...state,
                customerModalVisible: true
            };
        case actionTypes.CLOSE_CUSTOMER_MODAL:
            return {
                ...state,
                customerModalVisible: false
            };
        case actionTypes.OPEN_CUSTOMER_FILE_MODAL:
            return {
                ...state,
                customerFileModalVisible: true
            };
        case actionTypes.CLOSE_CUSTOMER_FILE_MODAL:
            return {
                ...state,
                customerFileModalVisible: false
            };
        case actionTypes.OPEN_CUSTOMER_PROFILE_MODAL:
            return {
                ...state,
                customerProfileModalVisible: true
            };
        case actionTypes.OPEN_CUSTOMER_DUPLICATES_MODAL:
            return {
                ...state,
                customerDuplicatesModalVisible: true
            };
        case actionTypes.CLOSE_CUSTOMER_DUPLICATES_MODAL:
            return {
                ...state,
                customerDuplicatesModalVisible: false
            };
        case actionTypes.CLOSE_CUSTOMER_PROFILE_MODAL:
            return {
                ...state,
                customerProfileModalVisible: false
            };
        case actionTypes.OPEN_CALENDAR_MODAL:
            return {
                ...state,
                calendarModalVisible: true
            };
        case actionTypes.CLOSE_CALENDAR_MODAL:
            return {
                ...state,
                calendarModalVisible: false
            };
        case actionTypes.OPEN_SEARCH_RESERVATION_MODAL:
            return {
                ...state,
                searchReservationModalVisible: true
            };
        case actionTypes.CLOSE_SEARCH_RESERVATION_MODAL:
            return {
                ...state,
                searchReservationModalVisible: false
            };
        case actionTypes.OPEN_BARESTHOFEEDBACK_MODAL:
            return {
                ...state,
                baresthoFeedbackModalVisible: true,
            };
        case actionTypes.CLOSE_BARESTHOFEEDBACK_MODAL:
            return {
                ...state,
                baresthoFeedbackModalVisible: false,
            };
        case actionTypes.OPEN_NOTIFICATION_TAB:
            return {
                ...state,
                notificationTabVisible: true
            };
        case actionTypes.CLOSE_NOTIFICATION_TAB:
            return {
                ...state,
                notificationTabVisible: false
            };
        case actionTypes.SET_NOTIFICATION_CENTER_ACTIVE_TAB: 
            return {
                ...state,
                notificationCenterActiveTab: action.tabKey
            }
        case actionTypes.UPDATE_SELECTED_DATE:
            return {
                ...state,
                timeline: action.timeline,
                selectedDay: action.selectedDay,
                stubSelectedDay: action.selectedDay,
            };
        case actionTypes.UPDATE_STUB_SELECTED_DATE:
            return {
                ...state,
                stubSelectedDay: action.stubSelectedDay,
            };
        case actionTypes.SET_ACTIVE_RESERVATION:
            return {
                ...state,
                activeReservation: action.activeReservation,
            };
        case actionTypes.OPEN_ARTEFACT_MODAL:
            return {
                ...state,
                artefactModalVisible: true,
            };
        case actionTypes.CLOSE_ARTEFACT_MODAL:
            return {
                ...state,
                artefactModalVisible: false,
            };
        case actionTypes.OPEN_TABLE_SUMMARY:
            return {
                ...state,
                tableSummaryVisible: true,
            };
        case actionTypes.CLOSE_TABLE_SUMMARY:
            return {
                ...state,
                tableSummaryVisible: false,
            };
        case actionTypes.INIT_SELECTED_TIME:
            return {
                ...state,
                selectedTime: action.time,
            }
        case actionTypes.UPDATE_SELECTED_TIME:
            return {
                ...state,
                selectedTime: action.newTime,
            };
        case actionTypes.SYNC_SELECTED_TIME:
            return {
                ...state,
                syncedTime: true,
            };
        case actionTypes.UNSYNC_SELECTED_TIME:
            return {
                ...state,
                syncedTime: false,
            };
        case actionTypes.OPEN_MEMO_VIEW:
            return {
                ...state,
                memoViewVisible: true,
            };
        case actionTypes.CLOSE_MEMO_VIEW:
            return {
                ...state,
                memoViewVisible: false,
            };
        case actionTypes.TOGGLE_MEMO_VIEW:
            return {
                ...state,
                memoViewVisible: !state.memoViewVisible,
            };
        
        default:
            return state;
    }
};

export default uiReducer;


// WEBPACK FOOTER //
// ./src/store/reducers/ui.js